import { useCallback } from 'react';

/**
 * Custom hook for haptic feedback
 * Uses the Vibration API when available
 */
export const useHaptics = () => {
  const isSupported = typeof navigator !== 'undefined' && 'vibrate' in navigator;

  /**
   * Light tap feedback
   */
  const lightTap = useCallback(() => {
    if (isSupported) {
      navigator.vibrate(10);
    }
  }, [isSupported]);

  /**
   * Medium tap feedback
   */
  const mediumTap = useCallback(() => {
    if (isSupported) {
      navigator.vibrate(25);
    }
  }, [isSupported]);

  /**
   * Drop impact feedback - simulates liquid hitting the bottle
   */
  const dropImpact = useCallback(() => {
    if (isSupported) {
      // Pattern: short pause, then impact
      navigator.vibrate([0, 50, 30]);
    }
  }, [isSupported]);

  /**
   * Success feedback
   */
  const success = useCallback(() => {
    if (isSupported) {
      navigator.vibrate([30, 50, 30]);
    }
  }, [isSupported]);

  /**
   * Error/warning feedback
   */
  const error = useCallback(() => {
    if (isSupported) {
      navigator.vibrate([50, 30, 50, 30, 50]);
    }
  }, [isSupported]);

  /**
   * Pour/dump feedback - longer pattern for pouring out
   */
  const pour = useCallback(() => {
    if (isSupported) {
      navigator.vibrate([20, 20, 20, 20, 20, 20, 40]);
    }
  }, [isSupported]);

  return {
    isSupported,
    lightTap,
    mediumTap,
    dropImpact,
    success,
    error,
    pour
  };
};
